<script lang="ts">
	import type { Form } from "#gen/forms/v1/forms_pb.js";
	import ConditionEditor from "#lib/components/page/components/form/conditionals/ConditionEditor.svelte";
	import FeatureFlagGate from "#lib/permissions/FeatureFlagGate.svelte";

	interface Props {
		form: Form;
		onChange?: (form: Form) => void;
		addRuleAtBottom?: boolean;
	}

	let { form, onChange, addRuleAtBottom = false }: Props = $props();
</script>

<FeatureFlagGate flag="conditional_form_fields">
	<ConditionEditor {form} {onChange} {addRuleAtBottom} />
</FeatureFlagGate>
